module.exports = __webpack_public_path__ + "img/passport-showcase-2.8b27dbaa.jpg";